import { render, staticRenderFns } from "./PostHeader.vue?vue&type=template&id=38181655&"
import script from "./PostHeader.vue?vue&type=script&lang=js&"
export * from "./PostHeader.vue?vue&type=script&lang=js&"
import style0 from "./PostHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports